export { default as default } from './supplier-form-new';
